import { render, staticRenderFns } from "./OfficialVehicles.vue?vue&type=template&id=9c4ae1ae&scoped=true"
import script from "./OfficialVehicles.vue?vue&type=script&lang=js"
export * from "./OfficialVehicles.vue?vue&type=script&lang=js"
import style0 from "./OfficialVehicles.vue?vue&type=style&index=0&id=9c4ae1ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4ae1ae",
  null
  
)

export default component.exports